var React = require('react');

function One (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","fill":"#1DB4FF","d":"M55.55 2.38l-4.17 9.84c.35.72-.46 1.01-1.71.14l-1.55-2.4a.97.97 0 00-1.35-.3L3.4 37.98c-.45.3-1.05.16-.9-.3l-1.67-1.9a.98.98 0 01.28-1.36L44.48 6.1c.45-.3 1.13-.9.29-1.36l-1.55-2.41c-.43-.66.05-1.52 1.27-1.51l10.18.32c.69.11 1.15.59.88 1.23zM4.66 45.79h7.62c1.4 0 2.53 1.54 2.53 3.41v15.37c0 1.89-1.14 3.42-2.53 3.42H4.66c-1.4 0-2.53-1.53-2.53-3.42V49.21c0-1.88 1.13-3.41 2.53-3.41zm19.67-11.95h7.62c1.4 0 2.54 1.53 2.54 3.42v27.31c0 1.89-1.14 3.42-2.54 3.42h-7.62c-1.4 0-2.53-1.53-2.53-3.42V37.26c0-1.89 1.14-3.42 2.53-3.42zM44.1 20.18h7.52c1.66 0 2.55 1.53 2.54 3.42v40.97c0 1.89-.88 3.42-2.53 3.42H44.1c-1.49 0-2.62-1.53-2.62-3.42V23.6c0-1.89 1.13-3.42 2.62-3.42z"}));
}

One.defaultProps = {"viewBox":"0 0 56 68","height":"100%","width":"100%"};

module.exports = One;

One.default = One;
